"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.guardarCarrito = exports.consultarCarrito = exports.consultaStock = exports.consultaOfertaExtendida = void 0;

var _legadoApi = require("../../../apis/legadoApi");

var _gerenciatdAdabyronUtils = require("@bit/gerenciatd.adabyron-utils.monitoring");

var _gerenciatdAdabyronUtils2 = require("@bit/gerenciatd.adabyron-utils.error");

var _productNormalizer = require("../../../normalizers/legado/productNormalizer");

var _gerenciatdUtils = _interopRequireWildcard(require("@bit/gerenciatd.utils.sonda"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var NODE_ENV = process.env.NODE_ENV;

var castCertiEntry = function castCertiEntry(entry) {
  if (sessionStorage && sessionStorage.getItem('datosUsuarioEntrada') && sessionStorage.getItem('datosUsuarioEntrada') !== '') {
    entry.datosUsuarioEntrada = JSON.parse(sessionStorage.getItem('datosUsuarioEntrada'));
  }

  return entry;
};

var getConsultaOfertaExtendidaError = function getConsultaOfertaExtendidaError(infoError) {
  var sonda = infoError.sonda,
      _infoError$req = infoError.req,
      req = _infoError$req === void 0 ? {} : _infoError$req,
      errorData = infoError.errorData;
  var newReq = {};
  var newResponse = req.response;

  if (typeof req.response === 'string') {
    newResponse = JSON.parse(req.response);
  }

  if ((typeof response === "undefined" ? "undefined" : _typeof(response)) === 'object') {
    newResponse = req.response;
  }

  newReq.status = newResponse.codError + ' - ' + newResponse.tipoError;
  newReq.statusText = newResponse.descError;
  var objError = (0, _gerenciatdAdabyronUtils2.normalizeObjError)(newReq);
  sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.ERROR, objError); // si el normalizador no consigue meter un response

  if (objError && !objError.response) {
    objError.response = {
      error: errorData || true
    };
  }

  return objError;
};

var getConsultaOfertaExtendidaSuccess = function getConsultaOfertaExtendidaSuccess(infoSuccess) {
  var sonda = infoSuccess.sonda,
      responseObj = infoSuccess.responseObj;
  var responseObjNormalize = (0, _productNormalizer.normalizeConsultaOfertaExtendida)(responseObj);
  sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.OK);
  return responseObjNormalize;
};

var checkObj = function checkObj(obj) {
  var str = '';

  for (var key in obj) {
    if (str !== '') {
      str += '&';
    }

    str += "".concat(key, "=").concat(encodeURIComponent(obj[key]));
  }

  return str;
};

var consultaOfertaExtendida = function consultaOfertaExtendida() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var idFront = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'webM';
  var idRequest = (0, _legadoApi.getUUID)(idFront);
  var sonda = new _gerenciatdUtils["default"]('PRODUCT.CONSULTA_OFERTA_EXTENDIDA', _gerenciatdAdabyronUtils.processName, context, idRequest);

  try {
    var URL_API = "".concat(_legadoApi.API.PRODUCT.CONSULTA_OFERTA_EXTENDIDA, "?").concat(idRequest);

    if (typeof data.tipConsulta !== 'undefined' && data.tipConsulta === 'C') {
      URL_API = _legadoApi.API.PRODUCT.CONSULTA_OFERTA_EXTENDIDA_EMPRESAS;
    }

    if (NODE_ENV && NODE_ENV !== 'test') {
      if (typeof MOCK_ALLOWED !== 'undefined' && MOCK_ALLOWED) {
        if (sessionStorage && sessionStorage.getItem('consultaOfertaExtendida') === 'mock') {
          URL_API = _legadoApi.API.PRODUCT.CONSULTA_OFERTA_EXTENDIDA_MOCK;
        } else if (sessionStorage && sessionStorage.getItem('firma') === 'si') {
          URL_API = _legadoApi.API.PRODUCT.CONSULTA_OFERTA_EXTENDIDA_FIRMA;
        }
      }
    }

    var input = {
      tipConsulta: typeof data.tipConsulta !== 'undefined' ? data.tipConsulta : '',
      segmento: 'GP',
      codTerminal: typeof data.codTerminal !== 'undefined' ? data.codTerminal : '',
      oper: typeof data.oper !== 'undefined' ? data.oper : '',
      codContrato: typeof data.codContrato !== 'undefined' ? data.codContrato : '',
      codModalidad: typeof data.codModalidad !== 'undefined' ? data.codModalidad : '',
      tipoPlan: typeof data.tipoPlan !== 'undefined' ? data.tipoPlan : ''
    };
    var dataEntry = 'ENTRADA=' + JSON.stringify(input);

    if (typeof data.tipoOferta !== 'undefined' && data.tipoOferta !== '') {
      input.tipoOferta = data.tipoOferta;
      dataEntry = checkObj(input);
    } else {
      input.codFrontal = idFront;
      dataEntry = 'ENTRADA=' + JSON.stringify(input);
    }

    return new Promise(function (resolve, reject) {
      var req = new XMLHttpRequest();
      sonda.startWS();
      req.open('POST', URL_API);

      req.onload = function () {
        if (req.status === 200) {
          var responseObj = null;

          if (typeof req.response === 'string') {
            responseObj = JSON.parse(req.response);
          }

          if ((typeof response === "undefined" ? "undefined" : _typeof(response)) === 'object') {
            responseObj = req.response;
          }

          if (responseObj.resultado === 1) {
            var objError = getConsultaOfertaExtendidaError({
              sonda: sonda,
              req: req
            });
            reject(objError);
          } else {
            var responseObjSuccess = getConsultaOfertaExtendidaSuccess({
              sonda: sonda,
              responseObj: responseObj
            });
            resolve(responseObjSuccess);
          }
        } else {
          var _objError = getConsultaOfertaExtendidaError({
            sonda: sonda,
            req: req
          });

          reject(_objError);
        }
      };

      req.onerror = function () {
        var objError = getConsultaOfertaExtendidaError({
          sonda: sonda,
          req: req
        });
        reject(objError);
      }; // Make the request


      req.setRequestHeader('Accept', 'application/json');
      req.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      req.send(dataEntry);
    });
  } catch (errorCatch) {
    sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.JS_ERROR);
    return null;
  }
};

exports.consultaOfertaExtendida = consultaOfertaExtendida;

var consultaStockError = function consultaStockError(infoError) {
  var sonda = infoError.sonda,
      _infoError$req2 = infoError.req,
      req = _infoError$req2 === void 0 ? {} : _infoError$req2,
      errorData = infoError.errorData;
  var newReq = {};
  var newResponse = req.response;

  if (typeof req.response === 'string') {
    newResponse = JSON.parse(req.response);
  }

  if ((typeof response === "undefined" ? "undefined" : _typeof(response)) === 'object') {
    newResponse = req.response;
  }

  newReq.status = newResponse.codError + ' - ' + newResponse.tipoError;
  newReq.statusText = newResponse.descError;
  var objError = (0, _gerenciatdAdabyronUtils2.normalizeObjError)(newReq);
  sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.ERROR, objError); // si el normalizador no consigue meter un response

  if (objError && !objError.response) {
    objError.response = {
      error: errorData || true
    };
  }

  return objError;
};

var consultaStockSuccess = function consultaStockSuccess(infoSuccess) {
  var sonda = infoSuccess.sonda,
      responseObj = infoSuccess.responseObj;
  sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.OK);
  return responseObj;
};

var consultaStock = function consultaStock(data) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var idFront = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'webM';
  var idRequest = (0, _legadoApi.getUUID)(idFront);
  var sonda = new _gerenciatdUtils["default"]('PRODUCT.CONSULTA_STOCK', _gerenciatdAdabyronUtils.processName, context, idRequest);

  try {
    var URL_API = "".concat(_legadoApi.API.PRODUCT.CONSULTA_STOCK, "?").concat(idRequest);

    if (NODE_ENV && NODE_ENV !== 'test') {
      if (typeof MOCK_ALLOWED !== 'undefined' && MOCK_ALLOWED) {
        if (sessionStorage && sessionStorage.getItem('consultaStock') === 'mock') {
          URL_API = _legadoApi.API.PRODUCT.CONSULTA_STOCK_MOCK;
        }
      }
    }

    var input = {
      codFrontal: idFront,
      catalogoBIStock: data.catalogoBIStock
    };
    var entry = data;
    return new Promise(function (resolve, reject) {
      var req = new XMLHttpRequest();
      sonda.startWS();
      req.open('POST', URL_API);

      req.onload = function () {
        if (req.status === 200) {
          var responseObj = null;

          if (typeof req.response === 'string') {
            responseObj = JSON.parse(req.response);
          }

          if ((typeof response === "undefined" ? "undefined" : _typeof(response)) === 'object') {
            responseObj = req.response;
          }

          if (responseObj.resultado === 1) {
            var objError = consultaStockError({
              sonda: sonda,
              req: req
            });
            reject(objError);
          } else {
            var responseObjSuccess = consultaStockSuccess({
              sonda: sonda,
              responseObj: responseObj,
              entry: entry
            });
            resolve(responseObjSuccess);
          }
        } else {
          var _objError2 = consultaStockError({
            sonda: sonda,
            req: req
          });

          reject(_objError2);
        }
      };

      req.onerror = function () {
        var objError = consultaStockError({
          sonda: sonda,
          req: req
        });
        reject(objError);
      }; // Make the request


      req.setRequestHeader('Accept', 'application/json');
      req.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      var data = 'ENTRADA=' + JSON.stringify(input);
      req.send(data);
    });
  } catch (errorCatch) {
    sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.JS_ERROR);
    return null;
  }
};

exports.consultaStock = consultaStock;

var consultarCarritoError = function consultarCarritoError(infoError) {
  var sonda = infoError.sonda,
      _infoError$req3 = infoError.req,
      req = _infoError$req3 === void 0 ? {} : _infoError$req3,
      errorData = infoError.errorData;
  var newReq = {};
  var newResponse = req.response;

  if (typeof req.response === 'string') {
    newResponse = JSON.parse(req.response);
  }

  if ((typeof response === "undefined" ? "undefined" : _typeof(response)) === 'object') {
    newResponse = req.response;
  }

  newReq.status = newResponse.codError + ' - ' + newResponse.tipoError;
  newReq.statusText = newResponse.descError;
  var objError = (0, _gerenciatdAdabyronUtils2.normalizeObjError)(newReq);
  sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.ERROR, objError); // si el normalizador no consigue meter un response

  if (objError && !objError.response) {
    objError.response = {
      error: errorData || true
    };
  }

  return objError;
};

var consultarCarritoSuccess = function consultarCarritoSuccess(infoSuccess) {
  var sonda = infoSuccess.sonda,
      responseObj = infoSuccess.responseObj;
  sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.OK);
  return responseObj;
};

var consultarCarrito = function consultarCarrito(data) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var idFront = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'webM';
  var idRequest = (0, _legadoApi.getUUID)(idFront);
  var sonda = new _gerenciatdUtils["default"]('PRODUCT.CONSULTAR_CARRITO', _gerenciatdAdabyronUtils.processName, context, idRequest);

  try {
    var URL_API = "".concat(_legadoApi.API.PRODUCT.CONSULTAR_CARRITO, "?").concat(idRequest);
    var input = {
      codFrontal: idFront,
      cuc: data.cuc
    };

    if (NODE_ENV && NODE_ENV !== 'test') {
      if (sessionStorage && sessionStorage.getItem('firma') === 'si' && (sessionStorage.getItem('devEnvironment') === 'CERTI' || sessionStorage.getItem('devEnvironment') === 'CERTI_PRE')) {
        input = castCertiEntry(input);
      }

      if (typeof MOCK_ALLOWED !== 'undefined' && MOCK_ALLOWED) {
        if (sessionStorage && sessionStorage.getItem('consultarCarrito') === 'mock') {
          URL_API = _legadoApi.API.PRODUCT.CONSULTAR_CARRITO_MOCK;
        } else if (sessionStorage && sessionStorage.getItem('firma') === 'si') {
          URL_API = _legadoApi.API.PRODUCT.CONSULTAR_CARRITO_FIRMA;
        }
      }
    }

    var entry = input;
    return new Promise(function (resolve, reject) {
      var req = new XMLHttpRequest();
      sonda.startWS();
      req.open('POST', URL_API);

      req.onload = function () {
        if (req.status === 200) {
          var responseObj = null;

          if (typeof req.response === 'string') {
            responseObj = JSON.parse(req.response);
          }

          if ((typeof response === "undefined" ? "undefined" : _typeof(response)) === 'object') {
            responseObj = req.response;
          }

          if (responseObj.resultado === 1) {
            var objError = consultarCarritoError({
              sonda: sonda,
              req: req
            });
            reject(objError);
          } else {
            var responseObjSuccess = consultarCarritoSuccess({
              sonda: sonda,
              responseObj: responseObj,
              entry: entry
            });
            resolve(responseObjSuccess);
          }
        } else {
          var _objError3 = consultarCarritoError({
            sonda: sonda,
            req: req
          });

          reject(_objError3);
        }
      };

      req.onerror = function () {
        var objError = consultarCarritoError({
          sonda: sonda,
          req: req
        });
        reject(objError);
      }; // Make the request


      req.setRequestHeader('Accept', 'application/json');
      req.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      var data = 'ENTRADA=' + JSON.stringify(input);
      req.send(data);
    });
  } catch (errorCatch) {
    sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.JS_ERROR);
    return null;
  }
};

exports.consultarCarrito = consultarCarrito;

var guardarCarritoError = function guardarCarritoError(infoError) {
  var sonda = infoError.sonda,
      _infoError$req4 = infoError.req,
      req = _infoError$req4 === void 0 ? {} : _infoError$req4,
      errorData = infoError.errorData;
  var newReq = {};
  var newResponse = req.response;

  if (typeof req.response === 'string') {
    newResponse = JSON.parse(req.response);
  }

  if ((typeof response === "undefined" ? "undefined" : _typeof(response)) === 'object') {
    newResponse = req.response;
  }

  newReq.status = newResponse.codError + ' - ' + newResponse.tipoError;
  newReq.statusText = newResponse.descError;
  var objError = (0, _gerenciatdAdabyronUtils2.normalizeObjError)(newReq);
  sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.ERROR, objError); // si el normalizador no consigue meter un response

  if (objError && !objError.response) {
    objError.response = {
      error: errorData || true
    };
  }

  return objError;
};

var guardarCarritoSuccess = function guardarCarritoSuccess(infoSuccess) {
  var sonda = infoSuccess.sonda,
      responseObj = infoSuccess.responseObj;
  sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.OK);
  return responseObj;
};

var guardarCarrito = function guardarCarrito(data) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var idFront = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'webM';
  var idRequest = (0, _legadoApi.getUUID)(idFront);
  var sonda = new _gerenciatdUtils["default"]('PRODUCT.GUARDAR_CARRITO', _gerenciatdAdabyronUtils.processName, context, idRequest);

  try {
    var URL_API = "".concat(_legadoApi.API.PRODUCT.GUARDAR_CARRITO, "?").concat(idRequest);
    var input = {
      codFrontal: idFront,
      datosCarrito: data.datosCarrito,
      codigoSAP: data.codigoSAP,
      numUnidades: data.numUnidades,
      cuc: data.cuc
    };

    if (NODE_ENV && NODE_ENV !== 'test') {
      if (sessionStorage && sessionStorage.getItem('firma') === 'si' && (sessionStorage.getItem('devEnvironment') === 'CERTI' || sessionStorage.getItem('devEnvironment') === 'CERTI_PRE')) {
        input = castCertiEntry(input);
      }

      if (typeof MOCK_ALLOWED !== 'undefined' && MOCK_ALLOWED) {
        if (sessionStorage && sessionStorage.getItem('guardarCarrito') === 'mock') {
          URL_API = _legadoApi.API.PRODUCT.GUARDAR_CARRITO_MOCK;
        } else if (sessionStorage && sessionStorage.getItem('firma') === 'si') {
          URL_API = _legadoApi.API.PRODUCT.GUARDAR_CARRITO_FIRMA;
        }
      }
    }

    var entry = input;
    return new Promise(function (resolve, reject) {
      var req = new XMLHttpRequest();
      sonda.startWS();
      req.open('POST', URL_API);

      req.onload = function () {
        if (req.status === 200) {
          var responseObj = null;

          if (typeof req.response === 'string') {
            responseObj = JSON.parse(req.response);
          }

          if ((typeof response === "undefined" ? "undefined" : _typeof(response)) === 'object') {
            responseObj = req.response;
          }

          if (responseObj.resultado === 1) {
            var objError = guardarCarritoError({
              sonda: sonda,
              req: req
            });
            reject(objError);
          } else {
            var responseObjSuccess = guardarCarritoSuccess({
              sonda: sonda,
              responseObj: responseObj,
              entry: entry
            });
            resolve(responseObjSuccess);
          }
        } else {
          var _objError4 = guardarCarritoError({
            sonda: sonda,
            req: req
          });

          reject(_objError4);
        }
      };

      req.onerror = function () {
        var objError = guardarCarritoError({
          sonda: sonda,
          req: req
        });
        reject(objError);
      }; // Make the request


      req.setRequestHeader('Accept', 'application/json');
      req.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      var data = 'ENTRADA=' + JSON.stringify(input);
      req.send(data);
    });
  } catch (errorCatch) {
    sonda.endWS(_gerenciatdUtils.CD_ELEMENT_TYPE.JS_ERROR);
    return null;
  }
};

exports.guardarCarrito = guardarCarrito;

//# sourceMappingURL=index.js.map